<template>
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3 items-center">
    <div class="w-full rounded-lg shadow body-element">
     
      <div class="card-header">
        <div class="page-titles">
            <h4>Sellers analyse stockages</h4>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="javascript:void(0)">Account manager: </a></li>
              <li class="breadcrumb-item active"><a href="javascript:void(0)">{{ currentUser.fullName }}</a></li><br>
              <li v-if="nbSellers" class="breadcrumb-item"><a href="javascript:void(0)">Nombre Sellers affected:  </a></li>
              <li v-if="nbSellers" class="breadcrumb-item active"><a href="javascript:void(0)">{{ nbSellers }}</a></li>
            </ol>
        </div>
        <div class=""> 
          <!-- <date-picker :disabled="loading" @change="DateRange" placeholder="Date ..."  format="YYYY-MM-DD"  class="w-full-imp" v-model="formData.date" range></date-picker> -->
          <!-- <button :disabled="loading" @click="downloadCsv" class="dt-button buttons-excel buttons-html5"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="fill-current mr-2"><path d="M23 0v20h-8v-2h6v-16h-18v16h6v2h-8v-20h22zm-12 13h-4l5-6 5 6h-4v11h-2v-11z"></path></svg><span>Excel</span></button> -->
        </div>
      </div>
     
      <div class="flex flex-col w-full h-auto p-5 pt-0" style="margin-bottom: 62px;">
                
                <div class="border-dashed border-2 border-green-600 p-4 pt-5">
                  <div class="grid grid-cols-2 gap-5">
                    
                      <div class="border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-green-500 flex flex-wrap items-stretch  relative  bg-white items-center rounded">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="currency" class="bg-white text-gray-700 px-1">Quantity InStock plus grand ou égal <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <div class="flex -mr-px justify-center p-1">
                          <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">Quantity</span>
                        </div>
                        <input type="number" :disabled="ProductNotUsed.loading||ProductNotUsed.dataExcel.loading"  v-model="ProductNotUsed.minQte" min="1" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
                      </div>
                      <div class="w-full border border-gray-500  hover:border-green-500  hover:border-green-500  focus-within:border-green-500 flex flex-wrap items-stretch  relative  bg-white items-center rounded">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="currency" class="bg-white text-gray-700 px-1">Derniers <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <div class="flex -mr-px justify-center p-1">
                          <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">Mois</span>
                        </div>
                        <v-select :disabled="ProductNotUsed.loading||ProductNotUsed.dataExcel.loading"  v-model="ProductNotUsed.minMois" :options="['1 mois','2 mois','3 mois','4 mois']" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none"></v-select>
                      </div>
                  </div>
                 <div class="flex flex-row justify-center space-x-2 mt-4">
                  <button @click="ProductsNotUsed('confirm')" class="flex text-white rounded text-center bg-green-500 py-2 px-10 items-center focus:outline-none relative loidingconfirm" :disabled="ProductNotUsed.loading||ProductNotUsed.dataExcel.loading"><loading :active.sync="ProductNotUsed.loading" :is-full-page="fullPage"></loading>Analyse</button>
                  
                  <!-- <button @click="exportToExcel('analyticsProducts')" v-if="ProductNotUsed.ProductNotExistInOrders.length>0 || ProductNotUsed.productsExistsInOrders.length>0" :disabled="ProductNotUsed.loading||ProductNotUsed.dataExcel.loading" class="inline-block  dt-button buttons-excel buttons-html5"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="fill-current mr-2"><path d="M23 0v20h-8v-2h6v-16h-18v16h6v2h-8v-20h22zm-12 13h-4l5-6 5 6h-4v11h-2v-11z"></path></svg>
                    <span v-if="ProductNotUsed.dataExcel.loading" class="inline-block loading-excel"> Exporting ({{ProductNotUsed.dataExcel.timer}}/ {{ProductNotUsed.paginate.total}}) <span>.</span><span>.</span><span>.</span> </span><span v-else>Export to Excel</span> 
                  </button> -->
                 </div>  
                </div>

                <div class="border-dashed border-2 border-green-600 p-4 pt-1 mt-2"> 
                    <h4 class="mb-4 text-center font-extrabold leading-none tracking-tight text-gray-700 dark:text-gray-600 uppercase">Des produits  <span class="underline underline-offset-3 decoration-8 decoration-green-400 dark:decoration-green-600">qui n'ont aucune orders</span> dans cette periode sélectionnée</h4>
                    <div v-if="ProductNotUsed.loading" class="flex justify-center gap-2">
                          <div class="w-5 h-5 rounded-full animate-pulse bg-green-600"></div>
                          <div class="w-5 h-5 rounded-full animate-pulse bg-green-600"></div>
                          <div class="w-5 h-5 rounded-full animate-pulse bg-green-600"></div>
                    </div>

                  <div v-if="ProductNotUsed.ProductNotExistInOrders.length>0" class="relative overflow-x-auto shadow-md sm:rounded-lg max-300">
                      <table class="w-full text-sm text-left rtl:text-right text-green-100 dark:text-green-100">
                          <thead class="text-xs text-white uppercase bg-green-500 border-b border-green-400 dark:text-white">
                              <tr>
                                  <th scope="col" class="px-6 py-3">
                                     Seller
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      Product ID
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      Product name
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      Quantity inStock
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      Nb Orders
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      warehouses
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      Date creation product
                                  </th>
                                  
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(item, index) in ProductNotUsed.ProductNotExistInOrders" :key="index" :value="item._id" class="bg-green-600 border-b border-green-400 hover:bg-green-500">
                                  <th scope="row" class="px-2 py-1 font-medium text-green-50 whitespace-nowrap dark:text-green-100">
                                     {{item.seller}}
                                  </th>
                                  <td class="px-2 py-1">
                                      {{item.id}}
                                  </td>
                                  <td class="px-2 py-1">
                                      {{item.name}}
                                  </td>
                                  <td class="px-2 py-1">
                                      {{item.stock}}
                                  </td>
                                  <td class="px-2 py-1">
                                      0
                                  </td>
                                  <td class="px-2 py-1">
                                    <span class="flex">
                                      <span v-for="(ware, index) in item.warehouses" :key="'wredd-'+index" class="intro-x">
                                        <img :src="$f.getCountryCode(ware)" class="w-4 h-4 rounded-full mr-2">
                                      </span>
                                    </span>
                                  </td>
                                  <td class="px-2 py-1">
                                      {{$moment(item.createdAt).format('yyyy-MM-DD')}}
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>

                </div>

                <div class="border-dashed border-2 border-green-600 p-4  pt-1 mt-2"> 
                      <h4 class="mb-4 text-center font-extrabold leading-none tracking-tight text-gray-700 dark:text-gray-600 uppercase">Des produits  <span class="underline underline-offset-3 decoration-8 decoration-green-400 dark:decoration-green-600">qui ont des orders</span> dans cette periode sélectionnée</h4>
                      <div v-if="ProductNotUsed.loading" class="flex justify-center gap-2">
                              <div class="w-5 h-5 rounded-full animate-pulse bg-green-600"></div>
                              <div class="w-5 h-5 rounded-full animate-pulse bg-green-600"></div>
                              <div class="w-5 h-5 rounded-full animate-pulse bg-green-600"></div>
                      </div>
                      <div v-if="ProductNotUsed.productsExistsInOrders.length>0" class="relative overflow-x-auto shadow-md sm:rounded-lg max-300">
                      <table class="w-full text-sm text-left rtl:text-right text-green-100 dark:text-green-100">
                          <thead class="text-xs text-white uppercase bg-green-500 border-b border-green-400 dark:text-white">
                              <tr>
                                  <th scope="col" class="px-6 py-3">
                                      Seller
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      Product ID
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      Product name
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      Quantity inStock
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      Nb Orders
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      warehouses
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                      Last Order created
                                  </th>
                                  
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(item, index) in ProductNotUsed.productsExistsInOrders" :key="index" :value="item._id" class="bg-green-600 border-b border-green-400 hover:bg-green-500">
                                  <th scope="row" class="px-2 py-1 font-medium text-green-50 whitespace-nowrap dark:text-green-100">
                                     {{ item.product?item.product.seller||'':''}}
                                  </th>
                                  <td class="px-2 py-1">
                                      {{ item.product?item.product.id||'':''}}
                                  </td>
                                  <td class="px-2 py-1">
                                      {{ item.product?item.product.name||'':''}}
                                  </td>
                                  <td class="px-2 py-1">
                                      {{ item.product?item.product.stock||'':''}}
                                  </td>
                                  <td class="px-2 py-1">
                                      {{item.count}}
                                  </td>
                                  <td class="px-2 py-1">
                                    <span class="flex">
                                      <span v-for="(ware, index) in item.product.warehouses||[]" :key="'wredd-'+index" class="intro-x">
                                        <img :src="$f.getCountryCode(ware)" class="w-4 h-4 rounded-full mr-2">
                                      </span>
                                    </span>
                                  </td>
                                  <td class="px-2 py-1">
                                      {{item.orderIds?$moment(item.orderIds.date).format('yyyy-MM-DD'):''}}
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                </div>
                 
          </div>

      
     
    </div>
  </div>
</template>




<script>
import spinner from "@/assets/spinner.gif";;
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
   },
  data() {
    return {
      loading: false,
      fullPage: false,
      loadingShowPay:0,
      ordersByseller: [],
      loadingShowPay:false,
      nbSellers:0,
      spinner:spinner,
      formData:{datas:[],date:[this.$moment(new Date(this.$moment().format('YYYY-MM-DD hh:mm')), 'LL').toDate(),this.$moment(new Date(this.$moment().format('YYYY-MM-DD hh:mm')), 'LL').toDate()]},
      ProductNotUsed:{dataExcel:{timer:0,loading:false,productsExistsInOrders:[],ProductNotExistInOrders:[]},loading:false,productsExistsInOrders:[],ProductNotExistInOrders:[],seller:null,minQte:1,minMois:'1 mois',paginate:{total: 0,currentpage: 1,lastpage: 0,per_page: 0}}
    };
  },
  async mounted() {
   
  },
  methods: {
    async ProductsNotUsed(type=null,filter={}){

          if(!this.ProductNotUsed.minMois){
              this.$toast.warning(`Please select last mois !`);
              return false;
          }
          if(this.ProductNotUsed.minQte && isNaN(this.ProductNotUsed.minQte)){
              this.$toast.warning(`Check the Quantity, it must be a number !`);
              return false;
          }
          if(!this.ProductNotUsed.minQte || (this.ProductNotUsed.minQte && !parseInt(this.ProductNotUsed.minQte))){
              this.$toast.warning(`Please select Quantity !`);
              return false;
          }
          
          this.ProductNotUsed.loading=true;
          const {content:resPr}= await this.$server.search("orders", {actionData:"ProductsNotUsed",minQte:this.ProductNotUsed.minQte,minMois:this.ProductNotUsed.minMois});
          this.ProductNotUsed.loading=false;

          console.log('resPr ProductsNotUsed-----',resPr)
         
          if(resPr && resPr.ProductNotExistInOrders){
              this.ProductNotUsed.ProductNotExistInOrders=resPr.ProductNotExistInOrders;
              this.ProductNotUsed.productsExistsInOrders=resPr.productsExistsInOrders;
              this.nbSellers=resPr.sellers;
          }      
              
    },
    randomHexColor(index) {
        const colors=["#ba96ce", "#679c9d", "#c6c42c", "#48b41b", "#5be4f0", "#57c4d8", "#a4d17a", "#225b8", "#be608b", "#96b00c", "#088baf", "#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#802234", "#6749e8", "#0971f0", "#8fb413", "#b2b4f0", "#c3c89d", "#c9a941", "#41d158", "#fb21a3", "#51aed9", "#5bb32d", "#807fb", "#21538e", "#89d534", "#d36647", "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3", "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", ];
        return 'background: ' + colors[index];        
    },
    DateRange(data){
      console.log('data date-------------------', data)
      if(data && data.filter(e => e).length === 0) {
        this.$toast.warning('Date Range obligatoir, svp selectioné une date');
        return false
      }
      if(data) this.$vm2.open('modaldate');
    },
    downloadCsv: function () {
          //this.dataExcel=[];
        if(this.ordersByseller.length>0) {
                var nameTable="SellersOrders";
                var htmls = "";
                var uri = 'data:application/vnd.ms-excel;base64,';
                var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'; 
                var base64 = function(s) {
                    return window.btoa(unescape(encodeURIComponent(s)))
                };

                var format = function(s, c) {
                    return s.replace(/{(\w+)}/g, function(m, p) {
                        return c[p];
                    })
                };
                const table =document.getElementById("p-table");
                htmls =table.outerHTML
                var ctx = {
                    worksheet : nameTable,
                    table : htmls
                }

                var link = document.createElement("a");
                link.download = nameTable+".xls";
                link.href = uri + base64(format(template, ctx));
                link.click();
        };
    },
  },
};
</script>

<style scoped>
.ant-table-cell-fix-right {
    position: -webkit-sticky !important;
    position: sticky !important;
    z-index: 2;
    background: #fff;
}
.ant-table-cell-fix-right-first:before, .ant-table-cell-fix-right-last:before {
    /* position: absolute;
    top: 0;
    bottom: -1px;
    right: 0;
    width: 30px;
    transform: translateX(60%);
    transition: box-shadow .3s;
    content: "";
    pointer-events: none;
    box-shadow: inset -10px 0 8px -8px rgb(0 0 0 / 15%); */
}
.buttons-excel {
    border: 1px solid rgb(89, 91, 94);
    background: rgba(255, 255, 255, 0.15);
    position: relative;
    box-sizing: border-box;
    padding: 11px 1em;
    border-radius: 2px;
    color: inherit;
    white-space: nowrap;
    overflow: hidden;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-decoration: none;
    outline: none;
    text-overflow: ellipsis;
    cursor: pointer;
    font-size: .88em;
    line-height: 1em;
    display: flex;
    float: right;
}
.card-header svg {
    display: inline-block;
}
.img-paym{
    display: inline-block;
    width: 20px;
}
.card-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 1.5rem 1.875rem 1.25rem;
}
.page-titles .breadcrumb {
  margin-bottom: 0;
  padding: 0;
  background: transparent;
}
.page-titles .breadcrumb li {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 18px;
  display: inline-block;
}
.breadcrumb-item.active {
  color: #6c757d;
}
.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.page-titles .breadcrumb li.active a {
  color: #007A64;
  font-weight: 600;
  text-transform: uppercase;
}
.page-titles .breadcrumb li {
  font-size: 18px;
}
.body-element{
  background-color: #F9F9F9;
}
.page-titles {
    margin-top: 0px;
    margin-bottom: 30px;
    margin-right: auto;
  }
  .page-titles h4, .page-titles .h4 {
  margin-bottom: 10px;
  margin-top: 0;
  color: #000;
  font-size: 1.75rem;
  font-weight: 600;
}
table>thead>tr:first-child th:last-child {
    border-top-right-radius: 4px;
}
.ant-table-cell-fix-right {
    position: -webkit-sticky!important;
    position: sticky!important;
    z-index: 2;
    background: #fff;
}
.ant-table-thead > tr > th{
 background: rgb(203 213 224);
}
.ant-table-cell-fix-right-first:after, .ant-table-cell-fix-right-last:after {
    position: absolute;
    top: 0;
    bottom: -1px;
    left: 0;
    width: 30px;
    transform: translateX(-100%);
    transition: box-shadow .3s;
    content: "";
    pointer-events: none;
    box-shadow: inset -10px 0 8px -8px rgb(0 0 0 / 15%);
}
.empty-row{
  /* background: repeating-linear-gradient(53deg,#bfc0c2 4%,#fcfcff 11px 6%,#fff 0 7%,#9d9c9c 15px) !important; */
  background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important;
}
.text-left-imp{
  text-align:left !important;
}
.fz-14{
  font-size:14px;
}
hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
}
table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
}
.px-5-im{
    padding-top: 5px !important;
    padding-bottom: 5px !important;
}
.empty-tab{
  height: 200px;
}
.text-center-imp{
  text-align: center !important;
}

.form-payement{
  min-height: 40rem
}
th, td {
    padding: 5px;
    text-align: center;    
}
.responsive-table {
  width: 100%;
  border-collapse: separate;
  text-indent: initial;
  border-spacing: 2px;
} 

.warehouses th{
    background-color: #efeff0 !important;
    color: #090909 !important;
}

.orders th{
  background-color: #a4a3a3 !important;
  color: black !important;
  font-size: 10px;
  font-weight: 700 !important;
}
.responsive-table thead {
    position: relative;
    clip: auto;
    height: auto;
    width: auto;
    overflow: auto;
}
.responsive-table thead th {
    background-color: #007A64;
    border: 1px solid #4e504a;
    font-weight: 500;   
    color: #faf4f4;
}
.responsive-table thead th:first-of-type {
  text-align: center;
}
.responsive-table tr {
  display: table-row;
}
.responsive-table th,
.responsive-table td {
  padding: 3px;
  vertical-align: middle;
  display: table-cell;
}
.spinner-g .spinner-1 {
    animation: fade 1.1s ease-in-out 0.18s infinite both;
}
.spinner-g .spinner-2 {
    animation: fade 1.1s ease-in-out 0.36s infinite both;
}
.spinner-g .spinner-3 {
    animation: fade 1.1s ease-in-out 0.54s infinite both;
}
.spinner-g * {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    background-color: #007A64;
    border-radius: 1rem;
    margin: 0 0.2rem;
}
@keyframes fade {
  0% {
      opacity: 0.35;
      transform: scale(0.87);
  }
  37.5% {
      opacity: 1;
      transform: scale(1);
  }
  75% {
      opacity: 0.35;
      transform: scale(0.87);
  }
  100% {
      opacity: 0.35;
      transform: scale(0.87);
  }
}

*>.intro-x:first-child {
 transform:translateX(50px)
}
*>.-intro-x:first-child,
*>.intro-x:first-child {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.1s;
 animation-delay:.1s
}
*>.-intro-x:first-child {
 transform:translateX(-50px)
}
*>.intro-y:first-child {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.1s;
 animation-delay:.1s
}
*>.intro-x:nth-child(2) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(2),
*>.intro-x:nth-child(2) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.2s;
 animation-delay:.2s
}
*>.-intro-x:nth-child(2) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(2) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.2s;
 animation-delay:.2s
}
*>.intro-x:nth-child(3) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(3),
*>.intro-x:nth-child(3) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.3s;
 animation-delay:.3s
}
*>.-intro-x:nth-child(3) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(3) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.3s;
 animation-delay:.3s
}
*>.intro-x:nth-child(4) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(4),
*>.intro-x:nth-child(4) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.4s;
 animation-delay:.4s
}
*>.-intro-x:nth-child(4) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(4) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.4s;
 animation-delay:.4s
}
*>.intro-x:nth-child(5) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(5),
*>.intro-x:nth-child(5) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.5s;
 animation-delay:.5s
}
*>.-intro-x:nth-child(5) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(5) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.5s;
 animation-delay:.5s
}
*>.intro-x:nth-child(6) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(6),
*>.intro-x:nth-child(6) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.6s;
 animation-delay:.6s
}
*>.-intro-x:nth-child(6) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(6) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.6s;
 animation-delay:.6s
}
*>.intro-x:nth-child(7) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(7),
*>.intro-x:nth-child(7) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.7s;
 animation-delay:.7s
}
*>.-intro-x:nth-child(7) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(7) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.7s;
 animation-delay:.7s
}
*>.intro-x:nth-child(8) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(8),
*>.intro-x:nth-child(8) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.8s;
 animation-delay:.8s
}
*>.-intro-x:nth-child(8) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(8) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.8s;
 animation-delay:.8s
}
*>.intro-x:nth-child(9) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(9),
*>.intro-x:nth-child(9) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.9s;
 animation-delay:.9s
}
*>.-intro-x:nth-child(9) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(9) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.9s;
 animation-delay:.9s
}
*>.intro-x:nth-child(10) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(10),
*>.intro-x:nth-child(10) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1s;
 animation-delay:1s
}
*>.-intro-x:nth-child(10) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(10) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1s;
 animation-delay:1s
}
*>.intro-x:nth-child(11) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(11),
*>.intro-x:nth-child(11) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.1s;
 animation-delay:1.1s
}
*>.-intro-x:nth-child(11) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(11) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.1s;
 animation-delay:1.1s
}
*>.intro-x:nth-child(12) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(12),
*>.intro-x:nth-child(12) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.2s;
 animation-delay:1.2s
}
*>.-intro-x:nth-child(12) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(12) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.2s;
 animation-delay:1.2s
}
*>.intro-x:nth-child(13) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(13),
*>.intro-x:nth-child(13) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.3s;
 animation-delay:1.3s
}
*>.-intro-x:nth-child(13) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(13) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.3s;
 animation-delay:1.3s
}
*>.intro-x:nth-child(14) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(14),
*>.intro-x:nth-child(14) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.4s;
 animation-delay:1.4s
}
*>.-intro-x:nth-child(14) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(14) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.4s;
 animation-delay:1.4s
}
*>.intro-x:nth-child(15) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(15),
*>.intro-x:nth-child(15) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.5s;
 animation-delay:1.5s
}
*>.-intro-x:nth-child(15) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(15) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.5s;
 animation-delay:1.5s
}
*>.intro-x:nth-child(16) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(16),
*>.intro-x:nth-child(16) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.6s;
 animation-delay:1.6s
}
*>.-intro-x:nth-child(16) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(16) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.6s;
 animation-delay:1.6s
}
*>.intro-x:nth-child(17) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(17),
*>.intro-x:nth-child(17) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.7s;
 animation-delay:1.7s
}
*>.-intro-x:nth-child(17) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(17) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.7s;
 animation-delay:1.7s
}
*>.intro-x:nth-child(18) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(18),
*>.intro-x:nth-child(18) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.8s;
 animation-delay:1.8s
}
*>.-intro-x:nth-child(18) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(18) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.8s;
 animation-delay:1.8s
}
*>.intro-x:nth-child(19) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(19),
*>.intro-x:nth-child(19) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.9s;
 animation-delay:1.9s
}
*>.-intro-x:nth-child(19) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(19) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.9s;
 animation-delay:1.9s
}
*>.intro-x:nth-child(20) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(20),
*>.intro-x:nth-child(20) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2s;
 animation-delay:2s
}
*>.-intro-x:nth-child(20) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(20) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2s;
 animation-delay:2s
}
*>.intro-x:nth-child(21) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(21),
*>.intro-x:nth-child(21) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.1s;
 animation-delay:2.1s
}
*>.-intro-x:nth-child(21) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(21) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.1s;
 animation-delay:2.1s
}
*>.intro-x:nth-child(22) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(22),
*>.intro-x:nth-child(22) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.2s;
 animation-delay:2.2s
}
*>.-intro-x:nth-child(22) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(22) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.2s;
 animation-delay:2.2s
}
*>.intro-x:nth-child(23) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(23),
*>.intro-x:nth-child(23) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.3s;
 animation-delay:2.3s
}
*>.-intro-x:nth-child(23) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(23) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.3s;
 animation-delay:2.3s
}
*>.intro-x:nth-child(24) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(24),
*>.intro-x:nth-child(24) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.4s;
 animation-delay:2.4s
}
*>.-intro-x:nth-child(24) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(24) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.4s;
 animation-delay:2.4s
}
*>.intro-x:nth-child(25) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(25),
*>.intro-x:nth-child(25) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.5s;
 animation-delay:2.5s
}
*>.-intro-x:nth-child(25) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(25) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.5s;
 animation-delay:2.5s
}
*>.intro-x:nth-child(26) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(26),
*>.intro-x:nth-child(26) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.6s;
 animation-delay:2.6s
}
*>.-intro-x:nth-child(26) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(26) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.6s;
 animation-delay:2.6s
}
*>.intro-x:nth-child(27) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(27),
*>.intro-x:nth-child(27) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.7s;
 animation-delay:2.7s
}
*>.-intro-x:nth-child(27) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(27) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.7s;
 animation-delay:2.7s
}
*>.intro-x:nth-child(28) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(28),
*>.intro-x:nth-child(28) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.8s;
 animation-delay:2.8s
}
*>.-intro-x:nth-child(28) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(28) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.8s;
 animation-delay:2.8s
}
*>.intro-x:nth-child(29) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(29),
*>.intro-x:nth-child(29) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.9s;
 animation-delay:2.9s
}
*>.-intro-x:nth-child(29) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(29) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.9s;
 animation-delay:2.9s
}
*>.intro-x:nth-child(30) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(30),
*>.intro-x:nth-child(30) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3s;
 animation-delay:3s
}
*>.-intro-x:nth-child(30) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(30) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3s;
 animation-delay:3s
}
*>.intro-x:nth-child(31) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(31),
*>.intro-x:nth-child(31) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.1s;
 animation-delay:3.1s
}
*>.-intro-x:nth-child(31) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(31) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.1s;
 animation-delay:3.1s
}
*>.intro-x:nth-child(32) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(32),
*>.intro-x:nth-child(32) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.2s;
 animation-delay:3.2s
}
*>.-intro-x:nth-child(32) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(32) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.2s;
 animation-delay:3.2s
}
*>.intro-x:nth-child(33) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(33),
*>.intro-x:nth-child(33) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.3s;
 animation-delay:3.3s
}
*>.-intro-x:nth-child(33) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(33) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.3s;
 animation-delay:3.3s
}
*>.intro-x:nth-child(34) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(34),
*>.intro-x:nth-child(34) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.4s;
 animation-delay:3.4s
}
*>.-intro-x:nth-child(34) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(34) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.4s;
 animation-delay:3.4s
}
*>.intro-x:nth-child(35) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(35),
*>.intro-x:nth-child(35) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.5s;
 animation-delay:3.5s
}
*>.-intro-x:nth-child(35) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(35) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.5s;
 animation-delay:3.5s
}
*>.intro-x:nth-child(36) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(36),
*>.intro-x:nth-child(36) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.6s;
 animation-delay:3.6s
}
*>.-intro-x:nth-child(36) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(36) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.6s;
 animation-delay:3.6s
}
*>.intro-x:nth-child(37) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(37),
*>.intro-x:nth-child(37) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.7s;
 animation-delay:3.7s
}
*>.-intro-x:nth-child(37) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(37) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.7s;
 animation-delay:3.7s
}
*>.intro-x:nth-child(38) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(38),
*>.intro-x:nth-child(38) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.8s;
 animation-delay:3.8s
}
*>.-intro-x:nth-child(38) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(38) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.8s;
 animation-delay:3.8s
}
*>.intro-x:nth-child(39) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(39),
*>.intro-x:nth-child(39) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.9s;
 animation-delay:3.9s
}
*>.-intro-x:nth-child(39) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(39) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.9s;
 animation-delay:3.9s
}
*>.intro-x:nth-child(40) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(40),
*>.intro-x:nth-child(40) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4s;
 animation-delay:4s
}
*>.-intro-x:nth-child(40) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(40) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4s;
 animation-delay:4s
}
*>.intro-x:nth-child(41) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(41),
*>.intro-x:nth-child(41) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.1s;
 animation-delay:4.1s
}
*>.-intro-x:nth-child(41) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(41) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.1s;
 animation-delay:4.1s
}
*>.intro-x:nth-child(42) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(42),
*>.intro-x:nth-child(42) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.2s;
 animation-delay:4.2s
}
*>.-intro-x:nth-child(42) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(42) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.2s;
 animation-delay:4.2s
}
*>.intro-x:nth-child(43) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(43),
*>.intro-x:nth-child(43) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.3s;
 animation-delay:4.3s
}
*>.-intro-x:nth-child(43) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(43) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.3s;
 animation-delay:4.3s
}
*>.intro-x:nth-child(44) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(44),
*>.intro-x:nth-child(44) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.4s;
 animation-delay:4.4s
}
*>.-intro-x:nth-child(44) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(44) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.4s;
 animation-delay:4.4s
}
*>.intro-x:nth-child(45) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(45),
*>.intro-x:nth-child(45) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.5s;
 animation-delay:4.5s
}
*>.-intro-x:nth-child(45) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(45) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.5s;
 animation-delay:4.5s
}
*>.intro-x:nth-child(46) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(46),
*>.intro-x:nth-child(46) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.6s;
 animation-delay:4.6s
}
*>.-intro-x:nth-child(46) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(46) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.6s;
 animation-delay:4.6s
}
*>.intro-x:nth-child(47) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(47),
*>.intro-x:nth-child(47) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.7s;
 animation-delay:4.7s
}
*>.-intro-x:nth-child(47) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(47) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.7s;
 animation-delay:4.7s
}
*>.intro-x:nth-child(48) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(48),
*>.intro-x:nth-child(48) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.8s;
 animation-delay:4.8s
}
*>.-intro-x:nth-child(48) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(48) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.8s;
 animation-delay:4.8s
}
*>.intro-x:nth-child(49) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(49),
*>.intro-x:nth-child(49) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.9s;
 animation-delay:4.9s
}
*>.-intro-x:nth-child(49) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(49) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.9s;
 animation-delay:4.9s
}
*>.intro-x:nth-child(50) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(50),
*>.intro-x:nth-child(50) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:5s;
 animation-delay:5s
}
*>.-intro-x:nth-child(50) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(50) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:5s;
 animation-delay:5s
}
@-webkit-keyframes intro-x-animation {
 to {
  opacity:1;
  transform:translateX(0)
 }
}
@keyframes intro-x-animation {
 to {
  opacity:1;
  transform:translateX(0)
 }
}
@-webkit-keyframes intro-y-animation {
 to {
  opacity:1;
  transform:translateY(0)
 }
}
@keyframes intro-y-animation {
 to {
  opacity:1;
  transform:translateY(0)
 }
}
</style>
